module.exports = __webpack_public_path__ + "assets/media/swallow_water_new.4e934586.mp4";